import { JSX } from 'react'

import { FormProvider, UseFormReturn } from 'react-hook-form'
import { useIntl } from 'react-intl'

import Button from 'app/components/base/Button'
import Dialog from 'app/components/base/Dialog'
import Stack from 'app/components/base/Stack'
import Text from 'app/components/base/Text'
import TextField from 'app/components/fields/TextField'
import useAppStore from 'app/store/app.store'
import { IS_NATIVE_APP } from 'app/utils/constants/env.constants'

const widthStyle = { width: { xs: '100%', sm: 350 } }

interface SendMatchNotificationDialogProps {
  open: boolean
  onClose: () => void
  onSend: () => void
  isSubmitting: boolean
  methods: UseFormReturn<MatchMeFV>
}

const SendMatchNotificationDialog = ({
  open,
  onClose,
  onSend,
  isSubmitting,
  methods
}: SendMatchNotificationDialogProps): JSX.Element => {
  const { formatMessage } = useIntl()
  const isTablet = useAppStore((state) => state.isTablet)

  return (
    <Dialog
      open={open}
      onClose={onClose}
      title={formatMessage({
        defaultMessage: 'Where should we send your match notification?'
      })}
      titleSx={{ mb: 2 }}
      actionsSx={{ alignItems: 'center', justifyContent: 'center' }}
      actions={
        <Stack
          direction="column"
          sx={{ ...(IS_NATIVE_APP ? { mt: 3 } : { ...widthStyle }) }}
        >
          <Button
            variant="contained"
            sx={{
              ...widthStyle,
              ...(IS_NATIVE_APP && {
                flex: 1,
                maxWidth: { xs: '100%', sm: 290, md: 350 },
                alignSelf: 'center'
              })
            }}
            loading={isSubmitting}
            onClick={onSend}
          >
            {formatMessage({ defaultMessage: 'Submit' })}
          </Button>
        </Stack>
      }
      {...(!IS_NATIVE_APP && {
        dialogSx: {
          '& .MuiDialog-paper': {
            py: 5,
            px: { xs: 2, sm: 6 },
            m: { xs: 2, md: 4 },
            width: '100%',
            maxWidth: 527
          }
        }
      })}
    >
      <FormProvider {...methods}>
        <Stack direction="column" spacing={3} sx={{ alignItems: 'center' }}>
          <Text
            variant="body1"
            sx={{
              color: 'text.third',
              textAlign: 'center',
              ...(IS_NATIVE_APP && { px: 4 }),
              ...widthStyle
            }}
          >
            {formatMessage({
              defaultMessage:
                'Enter your email so we can notify you when the part becomes available!'
            })}
          </Text>

          <TextField
            key="email"
            name="email"
            label={formatMessage({ defaultMessage: 'Email' })}
            formControlProps={{
              sx: {
                ...widthStyle,
                ...(IS_NATIVE_APP && { px: isTablet ? 0 : 4 })
              }
            }}
          />
        </Stack>
      </FormProvider>
    </Dialog>
  )
}

export default SendMatchNotificationDialog
